import { BackArrow } from "@assets";
import { LBtn, LFlex } from "@components";

export const GoBack = ({ onClick, title }: GoBackProps): JSX.Element => {
    return (
        <div className="tabs px-5 pb-5 has-background-primary-dark is-size-7 has-text-weight-medium">
            <LFlex row alignCenter justifyCenter>
                <LBtn variation="unstyled" smallSpacing onClick={onClick}>
                    <BackArrow />
                </LBtn>
                <p className="ml-3 mb-1 has-text-weight-bold has-text-white is-size-6">{title}</p>
            </LFlex>
        </div>
    );
};

interface GoBackProps {
    onClick: () => void;
    title: string;
}
